import e from"styled-components";const o=e.div`
	display: flex;
	align-items: center;
	padding: 4px;
	height: 40px;
	background-color: ${({theme:e})=>e.bg.primary};
	border-radius: 8px;
	box-sizing: border-box;
	overflow: hidden;
	border: none;
	width: 100%;

	&:hover {
		background-color: ${({theme:e})=>e.hover.black15};
		transition: background-color 0.1s ease;
	}
`,r=e.div`
	border: 1px solid ${({theme:e})=>e.border.black15};
	border-radius: 4px;
	background-color: ${({theme:e})=>e.bg.secondary};
	width: 32px;
	height: 32px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
`,i=e.span`
	padding: 0 8px;
	font-size: 13px;
	text-overflow: ellipsis;
	flex: 1;
	overflow: hidden;
	white-space: nowrap;
`;e.div`
	display: grid;
	place-content: center;
	width: 24px;
	height: 24px;
`;export{o as IconPickerContainer,i as IconPickerLabel,r as IconPickerTile};
